import { AUTH_TOKEN_TYPE } from '@config/auth';
import { HTTP_HEADER_NAME } from '@config/net';

import { httpFetch, HttpFetchResponse } from '@services/base/http-fetch';
import { ServiceAuthData } from '@types';

import {
  AuthedHttpFetchConfig,
  AuthedHttpFetchHeaders,
  AuthedHttpFetchOwnHeaders,
  AuthedHttpFetchResult,
} from './types';

const _authedHttpFetch = <
  R,
  D = undefined,
  P = undefined,
  H extends AuthedHttpFetchHeaders = undefined
>(
  url: string,
  authData: ServiceAuthData,
  config?: AuthedHttpFetchConfig<D, P, H>
): AuthedHttpFetchResult<R> => {
  const authedHttpOwnHeaders = {
    [HTTP_HEADER_NAME.AUTHORIZATION]: `${AUTH_TOKEN_TYPE} ${authData.accessToken}`,
  };

  const nextConfig = {
    ...config,
    headers: {
      ...authedHttpOwnHeaders,
      ...config?.headers,
    },
  };

  return httpFetch<
    R,
    D,
    P,
    AuthedHttpFetchOwnHeaders | (AuthedHttpFetchOwnHeaders & H)
  >(url, nextConfig);
};

export const authedHttpFetch = <
  R,
  D = undefined,
  P = undefined,
  H extends AuthedHttpFetchHeaders = undefined
>(
  url: string,
  authData: ServiceAuthData,
  config?: AuthedHttpFetchConfig<D, P, H>
): AuthedHttpFetchResult<R> => {
  const { promise, cancel } = _authedHttpFetch<R, D, P, H>(
    url,
    authData,
    config
  );

  return {
    promise: promise //
      .catch((response: HttpFetchResponse<R>) => {
        // @todo re-login
        throw response;
      }),
    cancel,
  };
};
